import { useContext } from "react";
import AccessContext from "../AccessContext";

/**
 * Retrieves the access context using the useContext hook.
 * @returns {object} The access context object.
 */
export const useAccessContext = () => {
  const access = useContext(AccessContext);
  return access;
};
